import React from 'react'
import Tags from 'components/Tags'
import FocusFadeGroup from 'components/FocusFadeGroup'
import Condition from 'components/Condition'
import { useTheme } from '@mui/material/styles'
import { useResponsiveBreakpoint } from 'hooks/useResponsiveBreakpoint'
import { Grid, Typography } from '@mui/material'
import { useFragment } from 'react-relay/hooks'
import { graphql } from 'relay-runtime'
import { ProfileRateFields_User$key } from '__generated__/ProfileRateFields_User.graphql'
import Suspense from 'components/Suspense'
import useStyles from './styles'
import RateEditDialog from './components/RateEditDialog'
import CompensationSummary from './components/CompensationSummary'
import ExperienceSummary from './components/ExperienceSummary'

interface IRateFieldsProps {
  user: ProfileRateFields_User$key
  editable?: boolean
}

function ProfileRateFields({ user: userFragmentRef, editable }: IRateFieldsProps) {
  const { classes } = useStyles()
  const theme = useTheme()
  const isTabletOrMobile = useResponsiveBreakpoint(theme.breakpoints.values.md)
  const [isEditorOpen, setEditorOpen] = React.useState(false)

  const user = useFragment(graphql`
    fragment ProfileRateFields_User on User {
      ...CompensationSummary_User
      ...ExperienceSummary_User
      ...RateEditDialog_User
    }
  `, userFragmentRef)

  return (
    <Typography variant="body1">
      <div className={classes.text}>
        <FocusFadeGroup focused={false}>
          <div className={classes.wrapper}>
            <Condition condition={isTabletOrMobile}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <CompensationSummary
                    editable={editable}
                    user={user}
                    onEditOpen={() => setEditorOpen(true)}
                  />
                </Grid>

                <Grid item xs={12}>
                  <ExperienceSummary
                    editable={editable || false}
                    user={user}
                  />
                </Grid>
              </Grid>
            </Condition>

            <Condition condition={!isTabletOrMobile}>
              <Tags>
                <CompensationSummary
                  editable={editable || false}
                  user={user}
                  onEditOpen={() => setEditorOpen(true)}
                />

                <ExperienceSummary
                  editable={editable || false}
                  user={user}
                />
              </Tags>
            </Condition>
          </div>

          {isEditorOpen && (
            <Suspense>
              <RateEditDialog
                user={user}
                onClose={() => setEditorOpen(false)}
              />
            </Suspense>
          )}
        </FocusFadeGroup>
      </div>
    </Typography>
  )
}

export default React.memo(ProfileRateFields)
